<div class="w-full flex justify-center resource-wrapper">
  <div class="md:w-[75%] w-[90%]">
    <div class="date-wrapper flex justify-between items-center flex-col-reverse md:flex-row">
      <div class="flex items-center md:w-[90%] w-full">
        <div
          class="flex flex-col flex-wrap justify-center items-start md:w-[90%] w-[85%]">
        </div>
      </div>
      <div
        *ngIf="loggedInUserRole === allRoles.superAdmin"
        class="w-full md:w-[20%] flex md:justify-center justify-end button-wrapper">
        <app-primary-button (handleClick)="editButtonClickHandler()"
                            class="w-[30%] md:w-full"
                            type="small">{{mode === 'view' ? 'Edit' :
          'Back To Editor'}}
        </app-primary-button>
      </div>
    </div>
    <div class="title-wrapper heading font-poppins flex items-center">
      <img [src]="(resourceDetails?.imgUrl || resourceDetails?.imageUrl) | cdnBaseUrl"
           alt="Thumbnail"
           class="w-28 h-28 mr-3 object-cover rounded-md " />
      {{resourceDetails?.title}}
    </div>
    <div class="description-wrapper ">
      {{resourceDetails?.description}}
    </div>
    <div class="categories-wrapper">
      <app-categories-chips [categories]="resourceDetails?.categories"></app-categories-chips>
    </div>
<!--    <div class="display-image-wrapper w-full" *ngIf="resourceDetails?.imgUrl || resourceDetails?.imageUrl">-->
<!--      <app-image [url]="(resourceDetails?.imgUrl || resourceDetails?.imageUrl) | cdnBaseUrl"-->
<!--                 alt=""></app-image>-->
<!--    </div>-->
    <div class="w-full">
      <app-resource-section *ngFor="let section of resourceDetails?.sections"
                            [section]="section"></app-resource-section>
    </div>
    <div *ngIf="resourceDetails?.relatedResources?.length>0"
         class="w-full related-resource-wrapper">
      <div class="section-title font-poppins font-bold">
        Related Resources
      </div>
      <div>
        <hr class="section-separation w-full">
      </div>
      <div
        class="sm:overflow-x-scroll w-full flex justify-between flex-wrap sm:flex-nowrap related-resource-card-wrapper">
        <div *ngFor="let resource of
        resourceDetails?.relatedResources"
             class="w-full sm:min-w-[25%] "
        >
          <app-resources-card
            [resource]="resource"
            class="w-full"></app-resources-card>
        </div>
      </div>
    </div>

    <!-- Session navigation links moved to bottom -->
    <div class="w-full session-navigation-wrapper">
      <div>
        <hr class="section-separation w-full">
      </div>
      <div class="font-regular date-content mt-4">
         <div class="font-regular date-content">
            {{resourceDetails?.statusName | titlecase }} {{
            resourceDetails?.publishOn ? ' | ' +
              (resourceDetails?.publishOn | date) : '' }}
          </div>
      </div>
      <div class="flex flex-wrap mt-4">
        <div *ngFor="let session of resourceDetails?.sessions"
             class="session-chip">
          {{"S" + session.id}}
        </div>
      </div>
    </div>
    <div class="categories-wrapper">
      <app-categories-chips [categories]="resourceDetails?.categories"></app-categories-chips>
    </div>
  </div>
</div>
